const checkmark = `<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
  <path
    d="M9.70711 1.29289C10.0976 1.68342 10.0976 2.31658 9.70711 2.70711L4.44448 7.96973C4.01491 8.39931 3.31843 8.39931 2.88885 7.96973L0.292893 5.37377C-0.0976311 4.98325 -0.0976311 4.35008 0.292893 3.95956C0.683417 3.56904 1.31658 3.56904 1.70711 3.95956L3.66667 5.91912L8.29289 1.29289C8.68342 0.902369 9.31658 0.902369 9.70711 1.29289Z"
  />
</svg>
`;
export {
  checkmark as default
};
//# sourceMappingURL=checkmark.mjs.map
